export default __webpack_public_path__ + "static/media/Gopal Krishan.049ca680.jpg";